import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import View from 'root/view/base';
import Modals from 'root/modals';
import Modal from 'root/module/modal';
import View_Browser_Extension from 'view/browser_extension';

var Widget_Code = View.extend({
    className: 'widget-code',
    with_user_id: true,

    project_id: 0, // 0: global code

    views: {
        browser_extension: {}
    },

    events: {
        'click .copy-code'                  : 'onCopyCode',
        'click .email-code'                 : 'onEmailCode',
        'click .widget-install-method'      : 'onSelectInstallMethod',
        'click .dropdown-project-select li' : 'onSelectProject',
        'click .verify-installation'        : 'onVerifyInstallation',
        'click .user-selection > div'       : 'onSelectUserType'
    },

    dom_handlers: {
        onVerifyInstallation: function(e) {
            e.preventDefault();
            Modals.verifyCodeInstallation(this.verify_project_id);
        },

        onCopyCode: function(e) {
            e.preventDefault();

            var pre = $(e.currentTarget).parents('.inline-copy').prev('pre');
            var range = document.createRange();

            range.selectNode(pre.get(0));
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);

            Util.copyText(pre.text(), function() {
                UI.success('Code copied');
            });
        },

        onEmailCode: function(e) {
            e.preventDefault();

            Modals.emailWidgetCode(this.project_id);
        },

        onSelectInstallMethod: function(e) {
            var element = $(e.currentTarget);
            var install_method = element.data('val');
            var title = '';
            var code = '';

            switch (install_method) {
                case 'npm':
                    title = 'Install with npm';
                    code = this.getNpmCode();
                    break;
                case 'react':
                    title = 'Install with React';
                    code = this.getReactCode();
                    break;
                case 'vue':
                    title = 'Install with Vue.js';
                    code = this.getVueCode();
                    break;
                case 'nextjs':
                    title = 'Install with Next.js';
                    code = this.getNextjsCode();
                    break;
                case 'angular':
                    title = 'Install with Angular';
                    code = this.getAngularCode();
                    break;
                case 'wordpress':
                    // redirect to wordpress plugin page
                    window.open('https://wordpress.org/plugins/userback/#description', '_blank');
                    return;
                case 'google-tag-manager':
                    // redirect to google tag manager page
                    window.open('https://docs.userback.io/docs/google-tag-manager', '_blank');
                   return;
            }

            Modal.open({
                title: title,
                width: 700,
                content: '<div class="widget-code">' + code + this.getInstallHelp(install_method) + '</div>'
            });
        },

        onSelectProject: function(e) {
            this.project_id = $(e.currentTarget).data('val');
            this.render();
        },

        onSelectUserType: function(e) {
            var type = $(e.currentTarget).data('type');

            this.with_user_id = type === 'with-user';
            this.render();
        }
    },

    initialize: function(options) {
        this.show_all_projects = !!options.show_all_projects;
        this.verify_project_id = options.verify_project_id;
        this.show_verify       = !!options.show_verify;

        this.views.browser_extension = new View_Browser_Extension();

        this.listenTo(Cache.widget,  'update', this.render);
        this.listenTo(Cache.project, 'change', this.render);
    },

    getInstallHelp: function(install_method) {
        switch (install_method) {
            case 'js':
                return '<div class="margin-top-12"><a target="help" class="primary font-weight-medium" rel="noopener" href="https://docs.userback.io/docs/quickstart-guide">Learn more about Userback Code <i class="fa-solid fa-square-arrow-up-right"></i></a></div>';
            case 'npm':
                return '<div class="margin-top-12"><a target="help" class="primary font-weight-medium" rel="noopener" href="https://docs.userback.io/docs/npm">Learn more about npm <i class="fa-solid fa-square-arrow-up-right"></i></a></div>';
            case 'react':
                return '<div class="margin-top-12"><a target="help" class="primary font-weight-medium" rel="noopener" href="https://docs.userback.io/docs/react">Learn more about React <i class="fa-solid fa-square-arrow-up-right"></i></a></div>';
            case 'vue':
                return '<div class="margin-top-12"><a target="help" class="primary font-weight-medium" rel="noopener" href="https://docs.userback.io/docs/vue">Learn more about Vue.js <i class="fa-solid fa-square-arrow-up-right"></i></a></div>';
            case 'nextjs':
                return '<div class="margin-top-12"><a target="help" class="primary font-weight-medium" rel="noopener" href="https://docs.userback.io/docs/nextjs">Learn more about Next.js <i class="fa-solid fa-square-arrow-up-right"></i></a></div>';
            case 'angular':
                return '<div class="margin-top-12"><a target="help" class="primary font-weight-medium" rel="noopener" href="https://docs.userback.io/docs/angularjs">Learn more about Angular <i class="fa-solid fa-square-arrow-up-right"></i></a></div>';
        }

        return '';
    },

    getAccessTokenSelector: function() {
        if (!Cache.account.hasLegacyProjectCode()) {
            return '';
        }

        var project_options = '';
        var projects = [];

        if (this.show_all_projects) {
            projects = Cache.project.models;
        } else {
            projects = Cache.getDefaultProject() ? [Cache.getDefaultProject()] : [];
        }

        projects.forEach((model) => {
            project_options += '<li data-val="' + model.id + '"' + (this.project_id === model.id ? ' class="selected"' : '') + '>' + model.escape('name') + '</li>';
        });

        var selector =
        '<div class="position-relative">' +
        '<div class="button-dropdown button-dropdown-left dropdown-project-select margin-bottom-12" data-update="true">' +
            '<button type="button" class="dropdown-select font-weight-medium">' +
                (this.project_id === 0 ? 'Global Access Token' : 'Project: ' + Cache.project.get(this.project_id).escape('name')) +
            '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-select">' +
                    '<li data-val="0"' + (this.project_id === 0 ? ' class="selected"' : '') + '>Global Access Token</li>' +
                    (this.show_all_projects && project_options ?
                    '<li class="separator"></li>' +
                    '<li class="dropdown-title">Select a Project</li>' : '') +
                    project_options +
                '</ul>' +
            '</div>' +
        '</div>' +
        '</div>';

        return selector;
    },

    getAccessToken: function() {
        if (this.project_id > 0) {
            //return Cache.account.id + '|' + this.project_id + '|' + Cache.account.get('domain_key');
            return 'P-' + Cache.project.get(this.project_id).get('access_token');
        } else {
            return 'A-' + Cache.account.get('domain_key');
        }
    },

    getCode: function() {
        var br = '\r\n';
        var widget_path;
        var widget_css;
        var request_url = '';
        var survey_url  = '';
        var track_url   = '';

        if (Cache.app.debug) {
            widget_path = Cache.app.host + '/dist/widget_dev/widget.min.js';
            widget_css  = Cache.app.host + '/dist/widget_dev/widget.min.css';
            request_url = Cache.app.configs.api_host;
            survey_url  = Cache.app.host;
            track_url   = Cache.app.host.replace('app.', 'events.');
        } else {
            widget_path = 'https://' + Cache.app.configs.cloudfront_host + '/widget/v1.js';
        }

        var access_token = this.getAccessToken();

        var code =
                '<div class="position-relative">' +
                    '<pre>' +
                    '&lt;script&gt;' + br +
                    '  window.Userback = window.Userback || {};' + br +
                    '  Userback.access_token = "<span class="access-token">' + access_token + '</span>";' + br +
                    (this.with_user_id ?
                    '  // identify your logged-in users (optional)' + br +
                    ('  Userback.user_data = {' + br +
                    '    id: "%123456%", // example data' + br +
                    '    info: {' + br +
                    '      name: "%someone%", // example data' + br +
                    '      email: "%someone@example.com%" // example data' + br +
                    '    }' + br +
                    '  };' + br) : '') +

                    // dev override
                    '<div style="font-size:0px;height:0px;line-height:0px;opacity:0;">' +
                    (widget_css ?
                        '  Userback.widget_css =  \'' + widget_css + '\';' + br : '') +
                    (survey_url ?
                    '  Userback.survey_url =  \'' + survey_url + '/s\';' + br : '') +
                    (request_url ?
                    '  Userback.request_url = \'' + request_url + '\';' + br : '') +
                    (track_url ?
                    '  Userback.track_url = \'' + track_url + '\';' + br : '') +
                    '</div>' +

                    '  (function(d) {' + br +
                    '    var s = d.createElement(\'script\');s.async = true;s.src = \'' + widget_path + '\';(d.head || d.body).appendChild(s);' + br +
                    '  })(document);' + br +
                    '&lt;/script&gt;' +
                    '</pre>' +

                    '<div class="inline-copy">' +
                        '<a href="#" class="copy-code tooltip" data-title="Copy Code"><i class="fa-solid fa-clone"></i></a>' +
                        '<a href="#" class="email-code tooltip" data-title="Share Code by Email"><i class="fa-solid fa-paper-plane"></i></a>' +
                    '</div>' +
                '</div>';

        // syntax highlighting
        // at some point we will need a proper tool to handle syntax highlighting
        code = code.replace(/([^'])(script)/g, '$1<span class="purple">$2</span>');

        // wildcard
        code = code.replace(/(%)([a-z0-9@.]+)(%)/g, '<span class="red">$2</span>');

        // comment
        code = code.replace(/(\/\/ .*)/gm, '<span class="green">$1</span>');

        return code;
    },

    getNpmCode: function() {
        var br = '\r\n';
        var access_token = this.getAccessToken();

        var code =
        '<div class="margin-bottom-4"><b>Step 1</b></div>' +
        '<div class="margin-bottom-12">Install the <b>@userback/widget</b> package:</div>' +
        '<div class="position-relative">' +
            '<pre>' +
                'npm install @userback/widget' +
            '</pre>' +
        '</div>' +

        '<div class="divider-32"></div>' +

        '<div class="margin-bottom-4"><b>Step 2</b></div>' +
        '<div class="margin-bottom-12">Initialize as soon as possible during your page load:</div>' +
        '<div class="position-relative">' +
            '<pre>' +
            'import Userback from "@userback/widget";' + br + br +

            (this.with_user_id ?
            '// identify your logged-in users (optional)' + br +
            'const options = {' + br +
            '  user_data: {' + br +
            '    id: "%123456%", // example data' + br +
            '    info: {' + br +
            '      name: "%someone%", // example data' + br +
            '      email: "%someone@example.com%" // example data' + br +
            '    }' + br +
            '  }' + br +
            '};' + br + br : '') +

            'Userback("<span class="access-token">' + access_token + '</span>"' + (this.with_user_id ? ', options' : '') + ');' + br +
            '</pre>' +
        '</div>';

        code = code.replace(/(youruser.[a-z]+)/g, '<span class="red">$1</span>');

        // wildcard
        code = code.replace(/(%)([a-z0-9@.]+)(%)/g, '<span class="red">$2</span>');

        // comment
        code = code.replace(/(\/\/ .*)/gm, '<span class="green">$1</span>');

        return code;
    },

    getReactCode: function() {
        var br = '\r\n';
        var access_token = this.getAccessToken();

        var code =
        '<div class="margin-bottom-4"><b>Step 1</b></div>' +
        '<div class="margin-bottom-12">Install the <b>@userback/widget</b> package:</div>' +
        '<div class="position-relative">' +
            '<pre>' +
            'npm install @userback/widget' +
            '</pre>' +
        '</div>' +

        '<div class="divider-32"></div>' +

        '<div class="margin-bottom-4"><b>Step 2</b></div>' +
        '<div class="margin-bottom-12">Initialize userback near the top of your React Tree like so:</div>' +
        '<div class="position-relative">' +
            '<pre>' +
            'import Userback from "@userback/widget";' + br + br +

            (this.with_user_id ?
            '// identify your logged-in users (optional)' + br +
            'const options = {' + br +
            '  user_data: {' + br +
            '    id: "%123456%", // example data' + br +
            '    info: {' + br +
            '      name: "%someone%", // example data' + br +
            '      email: "%someone@example.com%" // example data' + br +
            '    }' + br +
            '  }' + br +
            '};' + br + br : '') +

            '// initialize Userback' + br +
            'const userback = await Userback("<span class="access-token">' + access_token + '</span>"' + (this.with_user_id ? ', options' : '') + ');' + br +
            '</pre>' +
        '</div>';

        code = code.replace(/(youruser.[a-z]+)/g, '<span class="red">$1</span>');

        // wildcard
        code = code.replace(/(%)([a-z0-9@.]+)(%)/g, '<span class="red">$2</span>');

        // comment
        code = code.replace(/(\/\/ .*)/gm, '<span class="green">$1</span>');

        return code;
    },

    getVueCode: function() {
        var br = '\r\n';
        var access_token = 'A-' + Cache.account.get('domain_key');

        var code =
        '<div class="margin-bottom-4"><b>Step 1</b></div>' +
        '<div class="margin-bottom-12">Install the <b>@userback/widget</b> package:</div>' +
        '<div class="position-relative">' +
            '<pre>' +
                'npm install @userback/widget' +
            '</pre>' +
        '</div>' +

        '<div class="divider-32"></div>' +

        '<div class="margin-bottom-4"><b>Step 2</b></div>' +
        '<div class="margin-bottom-12">Set up the Userback plugin using <b>App.use</b> to install it into the global scope under <b>$userback</b>:</div>' +
        '<div class="position-relative">' +
            '<pre>' +
            'import Userback from "@userback/widget";' + br + br +

            'const token = "<span class="access-token">' + access_token + '</span>";' + br +

            (this.with_user_id ?
            '// identify your logged-in users (optional)' + br +
            'const options = {' + br +
            '  user_data: {' + br +
            '    id: "%123456%", // example data' + br +
            '    info: {' + br +
            '      name: "%someone%", // example data' + br +
            '      email: "%someone@example.com%" // example data' + br +
            '    }' + br +
            '  }' + br +
            '};' + br + br : '') +
            '// Initialize Userback before mounting the app' + br +
            'Userback(token' + (this.with_user_id ? ', options' : '') + ').then((userback) => {' + br +
            '  const app = createApp(App);' + br +
            '  // Make Userback instance globally available' + br +
            '  app.config.globalProperties.$userback = userback;' + br +
            '  app.mount("#app");' + br +
            '});' + br +
        '</div>';

        code = code.replace(/(youruser.[a-z]+)/g, '<span class="red">$1</span>');

        // wildcard
        code = code.replace(/(%)([a-z0-9@.]+)(%)/g, '<span class="red">$2</span>');

        // comment
        code = code.replace(/(\/\/ .*)/gm, '<span class="green">$1</span>');

        return code;
    },

    getNextjsCode: function() {
        var br = '\r\n';
        var access_token = this.getAccessToken();

        var code =
        '<div class="margin-bottom-4"><b>Step 1</b></div>' +
        '<div class="margin-bottom-12">Install the <b>@userback/widget</b> package:</div>' +
        '<div class="position-relative">' +
            '<pre>' +
            'npm install @userback/widget' +
            '</pre>' +
        '</div>' +

        '<div class="divider-32"></div>' +

        '<div class="margin-bottom-4"><b>Step 2</b></div>' +
        '<div class="margin-bottom-12">Initialize as soon as possible during your page load:</div>' +
        '<div class="position-relative">' +
            '<pre>' +
            'import Userback from "@userback/widget";' + br + br +

            (this.with_user_id ?
            '// identify your logged-in users (optional)' + br +
            'const options = {' + br +
            '  user_data: {' + br +
            '    id: "%123456%", // example data' + br +
            '    info: {' + br +
            '      name: "%someone%", // example data' + br +
            '      email: "%someone@example.com%" // example data' + br +
            '    }' + br +
            '  }' + br +
            '};' + br + br : '') +

            '// initialize Userback' + br +
            'const userback = await Userback("<span class="access-token">' + access_token + '</span>"' + (this.with_user_id ? ', options' : '') + ');' + br +
            '</pre>' +
        '</div>';

        code = code.replace(/(youruser.[a-z]+)/g, '<span class="red">$1</span>');

        // wildcard
        code = code.replace(/(%)([a-z0-9@.]+)(%)/g, '<span class="red">$2</span>');

        // comment
        code = code.replace(/(\/\/ .*)/gm, '<span class="green">$1</span>');

        return code;
    },

    getAngularCode: function() {
        var br = '\r\n';
        var access_token = this.getAccessToken();

        var code =
        '<div class="margin-bottom-4"><b>Step 1</b></div>' +
        '<div class="margin-bottom-12">Install the <b>@userback/widget</b> package:</div>' +
        '<div class="position-relative">' +
            '<pre>' +
                'npm install @userback/widget' +
            '</pre>' +
        '</div>' +

        '<div class="divider-32"></div>' +

        '<div class="margin-bottom-4"><b>Step 2</b></div>' +
        '<div class="margin-bottom-12">Set up the Userback plugin in <b>main.ts</b> after bootstrapping the app.</div>' +
        '<div class="position-relative">' +
            '<pre>' +
            'import Userback from "@userback/widget";' + br + br +
            'import { bootstrapApplication } from "@angular/platform-browser";' + br +
            'import { appConfig } from "./app/app.config";' + br +
            'import { AppComponent } from "./app/app.component"; ' + br +
            'import Userback from "@userback/widget";' + br + br +

            (this.with_user_id ?
            '// identify your logged-in users (optional)' + br +
            'const options = {' + br +
            '  user_data: {' + br +
            '    id: "%123456%", // example data' + br +
            '    info: {' + br +
            '      name: "%someone%", // example data' + br +
            '      email: "%someone@example.com%" // example data' + br +
            '    }' + br +
            '  }' + br +
            '};' + br + br : '') +

            'bootstrapApplication(AppComponent, appConfig)' + br +
            '  .then(() => {' + br +
            '    // After app is bootstrapped, initialize Userback' + br +
            '    Userback("<span class="access-token">' + access_token + '</span>"' + (this.with_user_id ? ', options' : '') + ')' + br +
            '      .then(() => {' + br +
            '        console.log("Userback successfully initialized");' + br +
            '      })' + br +
            '  })' + br +
            '</pre>' +
        '</div>';

        code = code.replace(/(youruser.[a-z]+)/g, '<span class="red">$1</span>');

        // wildcard
        code = code.replace(/(%)([a-z0-9@.]+)(%)/g, '<span class="red">$2</span>');

        // comment
        code = code.replace(/(\/\/ .*)/gm, '<span class="green">$1</span>');

        return code;
    },

    render: function() {
        // add two selection box, one for users with logins, one for website visitors without logins
        // two sections div boxes on same line, the space are half half
        var selection_content =
        '<div class="user-selection grid-6-6 grid-gap-80 grid-12-mobile grid-gap-36-mobile margin-bottom-24">' +
            '<div class="' + (this.with_user_id ? ' selected' : '') + ' tooltip" data-title="Best for web apps" data-position="down" data-offset="0,-10" data-type="with-user">' +
                '<div class="font-weight-semibold">For logged in users <span class="badge-primary-invert badge-small">Recommended</span></div>' +
                '<p class="font-weight-regular">Collect feedback and include user data from your logged-in users.</p>' +
            '</div>' +
            '<div class="' + (!this.with_user_id ? ' selected' : '') + ' tooltip" data-title="Best for websites" data-position="down" data-offset="0,-10" data-type="without-user">' +
                '<div class="font-weight-semibold">For website visitors without logins</div>' +
                '<p class="font-weight-regular">Collect feedback from anonymous website visitors who aren\'t logged in.</p>' +
            '</div>' +
        '</div>';


        var content =
        (this.show_verify ?
        '<button type="button" class="verify-installation small tertiary">Verify Installation</button>' : '') +
        selection_content +
        // JavaScript code
        '<div class="font-weight-semibold flex-start"><img src="/image/javascript_logo.png" class="margin-right-4 rounded-corner-small" width="24" height="24">JavaScript</div>' +
        '<p class="margin-bottom-16">Paste the Userback code before the closing <span class="font-weight-semibold">&lt;/body&gt;</span> tag on every page you wish to trigger the feedback widget and survey forms, and then <a href="#" class="verify-installation primary font-weight-medium">verify your installation</a>.</p>' +
        (this.with_user_id ?
        '<p>To track your logged-in users, replace the example <span class="font-weight-semibold">user_data</span> with your own user data.</p>' : '') +

        this.getAccessTokenSelector() +
        this.getCode() +

        '<div class="flex-between">' +
            this.getInstallHelp('js') +
        '</div>' +

        '<div class="divider-32"></div>' +

        // npm, react, vue
        '<div class="font-weight-semibold">Or, install with a package</div>' +
        '<div class="divider-12"></div>' +
        '<div class="install-method">' +
            '<div class="widget-install-method" data-val="npm">' +
                '<img src="/image/npm_logo.png">' +
                '<span>npm</span>' +
            '</div>' +
            '<div class="widget-install-method" data-val="react">' +
                '<img src="/image/react_logo.png">' +
                '<span>React</span>' +
            '</div>' +
            '<div class="widget-install-method" data-val="vue">' +
                '<img src="/image/vue_logo.png">' +
                '<span>Vue.js</span>' +
            '</div>' +
            '<div class="widget-install-method" data-val="nextjs">' +
                '<img src="/image/nextjs_logo.png">' +
                '<span>Nextjs</span>' +
            '</div>' +
            '<div class="widget-install-method" data-val="angular">' +
                '<img src="/image/angularjs_logo.png">' +
                '<span>Angular</span>' +
            '</div>' +
            '<div class="widget-install-method" data-val="wordpress">' +
                '<img src="/image/wordpress_logo.png">' +
                '<span>WordPress</span>' +
            '</div>' +
            '<div class="widget-install-method" data-val="google-tag-manager">' +
                '<img src="/image/google_tag_manager.png">' +
                '<span>Google Tag Manager</span>' +
            '</div>' +
        '</div>' +

        '<hr>' +

        // browser extension
        '<div class="font-weight-semibold">Browser Extensions</div>' +
        '<p>Collect feedback internally? Install browser extension to get started quickly.</p>' +
        '<div class="region-browser-extensions margin-bottom-64"></div>';

        this.$el.html(content);

        this.views.browser_extension.render().$el.appendTo(this.$el.find('.region-browser-extensions'));

        return this;
    }
});

export default Widget_Code;
